/** KiCanvas viewer: do not auto-fetch revision bytes above this size (catalog `byte_size`). */
export const KICANVAS_VIEWER_AUTOLOAD_MAX_BYTES = 4 * 1024 * 1024;

/** Revision-file GET budget for explicit viewer loads (AbortSignal.timeout). */
export const KICANVAS_VIEWER_FETCH_TIMEOUT_MS = 60_000;

export function viewerAutoloadAllowed(byteSize: number | null | undefined): boolean {
  if (byteSize == null || !Number.isFinite(byteSize)) return true;
  return byteSize <= KICANVAS_VIEWER_AUTOLOAD_MAX_BYTES;
}

export function viewerLoadFailureMessage(err: unknown, signal?: AbortSignal | null): string {
  if (signal?.aborted || (err instanceof DOMException && err.name === "AbortError")) {
    const reason = signal?.reason;
    if (reason instanceof DOMException && reason.name === "TimeoutError") {
      return "Loading this file timed out. Try again or open a smaller revision.";
    }
    return "Loading this file was cancelled.";
  }
  if (err instanceof Error && err.message) return err.message;
  return "Loading this file failed.";
}
